export default __webpack_public_path__ + "02a2f2e768604107981879df41746761.jpg";